const paths = {
	show: (importLogId: number) =>
		`${process.env.NEXT_PUBLIC_API_HOST}/api/admin/import_log_error_downloads?import_log_id=${importLogId}`
} as const;

export const getDownloadPath = (importLogId: number): string =>
	paths.show(importLogId);
